import { Component, OnInit, ViewChild } from '@angular/core';
import { AggridsaciComponent } from '../../advantage/aggridsaci/aggridsaci.component';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { ConprecenService } from "../conservicios/conprecen.service";
import { Detprecen } from "../coninterfaces/condetprecen";
import { Encprecen } from "../coninterfaces/conencprecen";
import { AggridBanComponent } from '../../ban/aggrid-ban/aggrid-ban.component';
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { CellEditorPrueba } from '../../advantage/config/cell-edit-prueba';
import { AuditoriagralService } from '../../advantage/advantageservices/auditoriagral.service';
import { InvbusquedaService } from '../../inv/invservicios/invbusqueda.service';
import { SegMaePermiso } from '../../advantage/advantageinterfaces/segmaepermiso';
import { PermisosService } from '../../advantage/advantageservices/permisos.service';
import { isNullOrUndefined } from 'util';
import { DatePipe } from '@angular/common';
import { UtilitariosService } from 'src/app/advantage/advantageservices/utilitarios.service';


@Component({
  selector: 'app-conprecen',
  templateUrl: './conprecen.component.html',
  styleUrls: ['../../advantage/styles/saciwebmae.css']
})
export class ConprecenComponent implements OnInit {
  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;
  btnNuevo: boolean;
  btnGuardar: boolean;
  btnBorrar: boolean;
  btnRegresar: boolean;
  indicador: any;

  btnNuevoGrid: boolean;
  errores: number;
  btnBorrarGrid: boolean;
  btnCancelarGrid: boolean;
  //ag-grid
  rowSelection = 'multiple';
  public frameworkComponents;
  rowStyle;
  defaultColDefPrecen

  opcion: string;
  types: SelectItem[];
  arregloCons: any[];
  displayDialogBusquedaFast: boolean;
  displayDialogSelectPCC: boolean;
  busquedacampos: string[];
  tabla: string;
  where: string;
  index: number;
  opcionbusqueda: string;
  consulta:string;

  spin: boolean;

  comboOpciones: any[];
  tipodetalle: string;

  selecteddetprecen: Detprecen = {}

  permisoprecen: SegMaePermiso;
  strNombreForma: string;
  auxreporte: number = 0;
  displayDialogReportes: boolean;
  displayToken = false;
  tokenusuario = '';

  columnDefsprecen = [
    { // 0
      headerName: 'Código', field: 'DETPRECEN_CODIGO', cellEditor: 'cellPrueba',
      editable: (params) => {

        return true;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 35,
          opcionbuscar: true
        }
      }
    },
    { // 1
      headerName: 'Descripción', field: 'DETPRECEN_DESCRIPCION', cellEditor: 'cellPrueba', width: 200,
      // , editable: true,
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 200
        }
      }
    },
    { // 2
      headerName: 'Cantidad', field: 'DETPRECEN_CANTIDAD', cellEditor: 'cellPrueba', width: 110,
      editable: (params) => {
        return true;
      },
      // , editable: true,
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 32,
          tienecalculos: true
        }
      }
    },
    { // 3
      headerName: 'Costo Unitario', field: 'DETPRECEN_COSTO', cellEditor: 'cellPrueba', width: 130,
      editable: (params) => {
        return true;
      },
      // , editable: true,
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 32,
          tienecalculos: true
        }
      }
    },
    { // 4
      headerName: 'Total', field: 'DETPRECEN_TOTAL', cellEditor: 'cellPrueba', width: 90,
      // , editable: true,
      editable: (params) => {

        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 32
        }
      }
    },
    { // 5
      headerName: 'Nom.',
      field: 'SELECCIONADO',
      cellRendererFramework: AggridBanComponent,
      editable: (params) => {
        return false;
      },
      width: 80,
      onCellClicked: (params) => {
        this.docSeleccionado(params);
      }
    },
    {
      headerName: 'Tipo', field: 'DETPRECEN_TIPODET', width: 200, editable: (params) => {

        return false;
      },
    },
  ]
  constructor(
    private init: NuevoComponentService, public conprecenService: ConprecenService,
    private messageService: MessageService, private datePipe: DatePipe,
    private confirmationService: ConfirmationService, private auditoriagral: AuditoriagralService,
    private busquedaSer: InvbusquedaService, private permisosService: PermisosService, private utilitariosService: UtilitariosService,
  ) {
    this.agTable();
  }
  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba
    };
    this.rowStyle = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
    };
    this.defaultColDefPrecen = {
      editable: true,
      width: 130,
      objeto: 'detprecen'
    };

  }
  async ngOnInit() {
    this.indicador = this.init.tabs[this.init.tabindex - 1].indice;

    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnBorrar = false;
    this.btnRegresar = true;
    this.btnNuevoGrid = true;
    this.btnBorrarGrid = true;
    this.btnCancelarGrid = true;
    this.index = 0;
    this.conprecenService.encprecen[this.indicador] = {}
    this.conprecenService.detprecen[this.indicador] = []
    this.selecteddetprecen = {}
    this.comboOpciones = [{ label: 'A', value: 'A' },
    { label: 'S', value: 'S' }, { label: 'C', value: 'C' }];
    this.tipodetalle = 'A';
    await this.getPermisos();
  }
  async getPermisos() {
    try {
      const data = await this.permisosService.getPermisosFrm(this.init.tabs[this.init.tabindex - 1].component);
      if (data !== null) {
        if (data[0] !== undefined) {
          this.permisoprecen = data[0];
        } else {
          this.permisoprecen = null;
        }
      } else {
        this.permisoprecen = null;
      }
    } catch (e) {
      this.permisoprecen = null;
      this.messageService.add({
        key: 'precen',
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo obtener los permisos del formulario'
      });
    }
  }
  manejarSenales(evento) {
    if (evento === 'Salir') {
      this.init.tabs.splice(this.init.tabindex, 1);
    }
    if (evento === 'Nuevo') {
      if (this.permisoprecen.PERTODO === 1) {
        this.nuevo();
      } else {
        if (this.permisoprecen.PERINSERCION === 1) {
          this.nuevo();
        } else {
          this.messageService.add({
            key: 'precen',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de inserción, acción denegada.'
          });
        }
      }
    }
    if (evento === 'Guardar') {
      if (this.index === 0) {
        if (this.permisoprecen.PERTODO === 1) {
          this.spin = true;
          this.guardar()
        } else {
          if (this.permisoprecen.PERACTUALIZACION === 1) {
            this.spin = true;
            this.guardar()
          } else {
            this.messageService.add({
              key: 'precen',
              severity: 'error',
              summary: 'Información',
              detail: 'El usuario no tiene permisos de actualización, acción denegada.'
            });
            this.spin=false
          }
        }
      }
    }
    if (evento === 'Cancelar') {
      this.cancelar()
    }
    if (evento === 'Borrar') {
      if (this.index === 0) {
        if (this.permisoprecen.PERTODO === 1) {
          this.confirmarborrar();
        } else {
          if (this.permisoprecen.PERELIMACION === 1) {
            this.confirmarborrar();
          } else {
            this.messageService.add({
              key: 'precen',
              severity: 'error',
              summary: 'Información',
              detail: 'El usuario no tiene permisos de eliminación, acción denegada.'
            });
          }
        }
      }
    }
    if (evento === 'Buscar') {
      if (this.permisoprecen.PERTODO === 1) {
        this.buscarregistro();
      } else {
        if (this.permisoprecen.PERSELECCION === 1) {
          this.buscarregistro();
        } else {
          this.messageService.add({
            key: 'precen',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de búsqueda, acción denegada.'
          });
        }
      }
    }
    if (evento === 'Imprimir') {

      this.strNombreForma = this.init.tabs[this.init.tabindex].component;
      this.auxreporte++;
      this.displayDialogReportes = true;
    }
  }
  confirmarborrar() {
    if (this.conprecenService.encprecen[this.indicador].ENCPRECEN_NUMERO !== '' && isNullOrUndefined(this.conprecenService.encprecen[this.indicador].ENCPRECEN_NUMERO) === false) {
      this.confirmationService.confirm({
        message: 'Está seguro de eliminar el registro?',
        header: 'Pregunta',
        icon: 'pi pi-exclamation-triangle',
        key: 'cnfprecen',
        acceptLabel: 'Si',
        rejectLabel: 'No',
        accept: async () => {
          const rs = await this.utilitariosService.enviarCorreoTokenElimprecen(this.conprecenService.usuarioEsquema.esquema,
            this.conprecenService.usuario.identificacion, this.conprecenService.encprecen[this.indicador].CLI_NOMBRE
          );
          if (rs) {
            this.tokenusuario = '';
            this.displayToken = true;
          }

        },
        reject: () => {
          this.confirmationService.close();
        }
      });
    }
  }
  async enterToken(event: any) {
    if (event.keyCode === 13) {
      const resp = await this.utilitariosService.validarToken(this.tokenusuario, this.conprecenService.usuario.identificacion);
      if (resp === true) {
        this.displayToken = false;
        this.eliminarregistro();

      } else {
        this.tokenusuario = '';
        this.messageService.add({
          key: 'prodUsuToken',
          severity: 'error',
          summary: 'Error de Actualización',
          detail: 'Token ingresado no coincide. Verifique su correo'
        });
      }
    }

  }
  async aceptarToken() {
    const resp = await this.utilitariosService.validarToken(this.tokenusuario, this.conprecenService.usuario.identificacion);
    if (resp === true) {
      this.displayToken = false;
      this.eliminarregistro();
    } else {
      this.tokenusuario = '';
      this.messageService.add({
        key: 'prodUsuToken',
        severity: 'error',
        summary: 'Error de Actualización',
        detail: 'Token ingresado no coincide. Verifique su correo'
      });
    }
  }

  cancelarToken() {
    this.displayToken = false;
  }
  async eliminarregistro() {
    try {
      await this.conprecenService.eliminarregistro(this.conprecenService.encprecen[this.indicador].ENCPRECEN_NUMERO);
      this.messageService.add({
        key: 'precen',
        severity: 'success',
        summary: 'Eliminar Presupuesto',
        detail: 'Se eliminó con éxito el registro'
      });
      this.auditoriagral.registrarAuditoria('CON_ENCPRECEN', this.conprecenService.encprecen[this.indicador].ENCPRECEN_NUMERO, 'E',
        '', '01', '', '', '', '').subscribe(() => { });
      this.btnNuevo = false;
      this.btnGuardar = true;
      this.btnBorrar = false;
      this.btnRegresar = true;
      this.btnNuevoGrid = true;
      this.btnBorrarGrid = true;
      this.btnCancelarGrid = true;
      this.conprecenService.encprecen[this.indicador] = {}
      this.conprecenService.detprecen[this.indicador] = []
      this.selecteddetprecen = {}
      document.getElementById('contorno').style.pointerEvents = 'none';
      this.aggrid.bloquearGrid();


    } catch (error) {
      this.messageService.add({
        key: 'precen',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al eliminar la información ' + error
      });
      return;
    }
  }
  cancelar() {
    try {
      if (isNullOrUndefined(this.conprecenService.encprecen[this.indicador].ENCPRECEN_NUMERO) || this.conprecenService.encprecen[this.indicador].ENCPRECEN_NUMERO === '') {
        this.btnNuevo = false;
        this.btnGuardar = true;
        this.btnBorrar = false;
        this.btnRegresar = true;
        this.btnNuevoGrid = true;
        this.btnBorrarGrid = true;
        this.btnCancelarGrid = true;
        this.tipodetalle = 'A'
        this.conprecenService.encprecen[this.indicador] = {}
        this.conprecenService.detprecen[this.indicador] = []
        this.selecteddetprecen = {}
        document.getElementById('contorno').style.pointerEvents = 'none';
        this.aggrid.bloquearGrid();
      } else {
        this.btnNuevo = false;
        this.btnGuardar = true;
        this.btnBorrar = false;
        this.btnRegresar = true;
        this.encontrarregistro(this.conprecenService.encprecen[this.indicador].ENCPRECEN_NUMERO)
      }
    } catch (error) {
      this.messageService.add({
        key: 'precen',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al refrescar la información ' + error
      });
      return;
    }
  }
  buscarregistro() {
    this.opcionbusqueda = 'BUSREGISTRO'
    this.types = [
      { label: 'Cod. Cliente', value: 'CLI_CODIGO' },
      { label: 'Nom. Cliente', value: 'CLI_NOMBRE' },
      { label: 'Fecha. Inicio', value: 'ENCPRECEN_FECHAINI' },
      { label: 'Fecha. Fin', value: 'ENCPRECEN_FECHAFIN' },
      { label: 'C. Costos', value: 'CEN_CODIGO' },

    ];

    this.busquedacampos = ['', '', '', '', ''];
    this.tabla = 'CON_ENCPRECEN b';
    this.where = ''
    this.consulta=' *, VEN_FNC_NOMBRE_CLIENTE(CLI_CODIGO,COM_CODIGO) AS CLI_NOMBRE'
    this.conprecenService.busquedaConPreCen().subscribe((res: any[]) => {
      if (res !== null) {
        res.map(x => {
          x.ENCPRECEN_FECHAINI = this.datePipe.transform(x.ENCPRECEN_FECHAINI, 'dd/MM/yyyy')
          x.ENCPRECEN_FECHAFIN = this.datePipe.transform(x.ENCPRECEN_FECHAFIN, 'dd/MM/yyyy')
        })
      }
      this.arregloCons = res;
      this.displayDialogBusquedaFast = true;
    });
  }
  async encontrarregistro(numero) {
    try {
      this.conprecenService.detprecen[this.indicador] = []
      const rs = await this.conprecenService.consultarEncabezadoprecen(numero);
      if (rs !== null) {
        this.btnNuevoGrid = false;
        this.btnBorrarGrid = false;
        this.btnCancelarGrid = false;
        for (const iterator of rs) {
          iterator.ENCPRECEN_FECHAINI = new Date(iterator.ENCPRECEN_FECHAINI)
          iterator.ENCPRECEN_FECHAFIN = new Date(iterator.ENCPRECEN_FECHAFIN)
          this.conprecenService.encprecen[this.indicador] = iterator
          const data = await this.conprecenService.consultarDetalleprecen(numero);
          if (data !== null) {
            
            for (const item of data) {
              item.DETPRECEN_CANTIDAD = Number(item.DETPRECEN_CANTIDAD).toFixed(2)
              item.DETPRECEN_COSTO = Number(item.DETPRECEN_COSTO).toFixed(2)
              item.DETPRECEN_TOTAL = Number(item.DETPRECEN_TOTAL).toFixed(2)
              item.DETPRECEN_ORIGENCON = item.DETPRECEN_ORIGENCON === '1' ? true : false
              item.SELECCIONADO=item.DETPRECEN_ORIGENCON
              item.LINEA=item.DETPRECEN_LINEA
            }
            this.conprecenService.detprecen[this.indicador] = data
          }
        }
        document.getElementById('contorno').style.pointerEvents = 'all';
      }
    } catch (error) {
      this.messageService.add({
        key: 'precen',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al consultar la información ' + error
      });
    }
  }
  async guardar() {
    try {
      let cont = 0;
      let strNombreCliente = '';
      const cntasnom = this.conprecenService.detprecen[this.indicador].filter(x => x.DETPRECEN_ORIGENCON === true && x.DETPRECEN_TIPODET === 'C')
      const cntas = this.conprecenService.detprecen[this.indicador].filter(x => x.DETPRECEN_ORIGENCON === false && x.DETPRECEN_TIPODET === 'C')

      const num = await this.conprecenService.validarcencodigo(this.conprecenService.encprecen[this.indicador].CEN_CODIGO);
      const er = await this.conprecenService.erClinombreProm(this.conprecenService.encprecen[this.indicador].CLI_CODIGO);

      if (er !== null) {
        if (er[0] !== undefined) {
          strNombreCliente = er[0].CLI_NOMBRE === null ? '' : er[0].CLI_NOMBRE;
        }
      }
      if (num !== null && num !== undefined) {
        for (const rs of num) {
          if (rs.NUMERO !== null && rs.NUMERO !== undefined && rs.NUMERO !== '') {
            cont = rs.NUMERO
          }
        }
      }
      if (cntasnom.length > 0) {
        const cuentas = Array.from(new Set(cntasnom.map(item =>
          item.DETPRECEN_CODIGO.toString()
        ).filter(x => x !== null && String(x).trim() !== '')
        )
        )
        const rs = await this.conprecenService.validacuentasnom(cuentas)
        if (rs !== null && rs !== undefined) {
          if (rs.length > 0) {
            this.messageService.add({
              key: 'precen',
              severity: 'error',
              summary: 'Error',
              detail: 'Hubo un error al validar las siguientes cuentas ya que no han sido utilizadas en nómina, por favor revisar: ' + rs.join(", ")
            });
            this.spin = false
            return;
          }
        }
      }
      if (cntas.length > 0) {
        const cuentas = Array.from(new Set(cntas.map(item =>
          item.DETPRECEN_CODIGO.toString()
        ).filter(x => x !== null && String(x).trim() !== '')
        )
        )
        const rs = await this.conprecenService.validacuentas(cuentas)
        if (rs !== null && rs !== undefined) {
          if (rs.length > 0) {
            this.messageService.add({
              key: 'precen',
              severity: 'error',
              summary: 'Error',
              detail: 'Hubo un error al validar las siguientes cuentas ya que han sido utilizadas en nómina, por favor revisar: ' + rs.join(", ")
            });
            this.spin = false
            return;
          }
        }
      }
      if (String(strNombreCliente).length === 0) {
        this.messageService.add({
          key: 'precen',
          severity: 'error',
          summary: 'Información',
          detail: 'El cliente ingresado no existe'
        });
        this.spin=false
        return;
      }
      if (cont === 0) {
        this.messageService.add({
          key: 'precen',
          severity: 'error',
          summary: 'Información',
          detail: 'El código del centro de costos ingresado no existe'
        });
        this.spin=false
        return;
      }
      if (isNullOrUndefined(this.conprecenService.encprecen[this.indicador].ENCPRECEN_FECHAINI) || this.conprecenService.encprecen[this.indicador].ENCPRECEN_FECHAINI === '') {
        this.messageService.add({
          key: 'precen',
          severity: 'error',
          summary: 'Información',
          detail: 'La fecha de inicio no puede estar vacía'
        });
        this.spin=false
        return;
      }
      if (isNullOrUndefined(this.conprecenService.encprecen[this.indicador].ENCPRECEN_FECHAFIN) || this.conprecenService.encprecen[this.indicador].ENCPRECEN_FECHAFIN === '') {
        this.messageService.add({
          key: 'precen',
          severity: 'error',
          summary: 'Información',
          detail: 'La fecha de finalización no puede estar vacía'
        });
        this.spin=false
        return;
      }
      if (isNullOrUndefined(this.conprecenService.encprecen[this.indicador].CLI_CODIGO) || this.conprecenService.encprecen[this.indicador].CLI_CODIGO === '') {
        this.messageService.add({
          key: 'precen',
          severity: 'error',
          summary: 'Información',
          detail: 'Debe seleccionar un cliente'
        });
        this.spin=false
        return;
      }
      if (isNullOrUndefined(this.conprecenService.encprecen[this.indicador].CEN_CODIGO) || this.conprecenService.encprecen[this.indicador].CEN_CODIGO === '') {
        this.messageService.add({
          key: 'precen',
          severity: 'error',
          summary: 'Información',
          detail: 'Debe seleccionar un centro de costos'
        });
        this.spin=false
        return;
      }
      if (this.conprecenService.detprecen[this.indicador].length === 0) {
        this.messageService.add({
          key: 'precen',
          severity: 'error',
          summary: 'Información',
          detail: 'El detalle no puede estar vacío'
        });
        this.spin=false
        return;
      }

      for (const iterator of this.conprecenService.detprecen[this.indicador]) {
        const rsdata: any = await this.conprecenService.encontrarArtCntaySer(iterator.DETPRECEN_CODIGO, iterator.DETPRECEN_TIPODET);
        let strCodigo = 0;
        if (rsdata !== null) {
          for (const rs of rsdata) {
            strCodigo = rs.NUMERO;
          }
        }
        if ((iterator.DETPRECEN_TIPODET === 'A' || iterator.DETPRECEN_TIPODET === 'Y' || iterator.DETPRECEN_TIPODET === 'Z') && strCodigo === 0) {//CDPJ
          this.messageService.add({
            key: 'precen',
            severity: 'error',
            summary: 'Información',
            detail: 'El artículo ' + iterator.DETPRECEN_CODIGO + ' no existe'
          });
          this.spin=false
          return
        }
        if (iterator.DETPRECEN_TIPODET === 'S' && strCodigo === 0) {
          this.messageService.add({
            key: 'precen',
            severity: 'error',
            summary: 'Información',
            detail: 'El servicio ' + iterator.DETPRECEN_CODIGO + ' no existe'
          });
          this.spin=false
          return
        }
        if (iterator.DETPRECEN_TIPODET === 'C' && strCodigo === 0) {
          this.messageService.add({
            key: 'precen',
            severity: 'error',
            summary: 'Información',
            detail: 'La cuenta contable ' + iterator.DETPRECEN_CODIGO + ' no existe'
          });
          this.spin=false
          return
        }
      }
      await this.finalmenteguardar();
    } catch (error) {
      this.messageService.add({
        key: 'precen',
        severity: 'error',
        summary: 'Información',
        detail: 'Hubo un error al validar la información ' + error
      });
      this.spin=false
      return;
    }
  }
  async finalmenteguardar() {
    try {
      if (isNullOrUndefined(this.conprecenService.encprecen[this.indicador].ENCPRECEN_NUMERO) || this.conprecenService.encprecen[this.indicador].ENCPRECEN_NUMERO === '') {
        if (this.conprecenService.encprecen[this.indicador].ENCPRECEN_FECHAINI.toString().includes('-')) {
          this.conprecenService.encprecen[this.indicador].ENCPRECEN_FECHAINI = this.datePipe.transform(this.conprecenService.encprecen[this.indicador].ENCPRECEN_FECHAINI, 'dd/MM/yyyy')
        }
        if (this.conprecenService.encprecen[this.indicador].ENCPRECEN_FECHAFIN.toString().includes('-')) {
          this.conprecenService.encprecen[this.indicador].ENCPRECEN_FECHAFIN = this.datePipe.transform(this.conprecenService.encprecen[this.indicador].ENCPRECEN_FECHAFIN, 'dd/MM/yyyy')
        }
        const rs = await this.conprecenService.insertarEncabezadoprecen(this.conprecenService.encprecen[this.indicador]);
        if (rs !== null) {
          for (const iterator of rs) {
            this.conprecenService.encprecen[this.indicador].ENCPRECEN_NUMERO = iterator.ENCPRECEN_NUMERO
            this.auditoriagral.registrarAuditoria('CON_ENCPRECEN', iterator.ENCPRECEN_NUMERO+'/'+this.conprecenService.encprecen[this.indicador].CLI_CODIGO
            +'/'+this.conprecenService.encprecen[this.indicador].CEN_CODIGO, 'I',
              '', '01', '', '', '', '').subscribe(() => { });
            for (const item of this.conprecenService.detprecen[this.indicador]) {
              item.DETPRECEN_ORIGENCON = item.DETPRECEN_ORIGENCON === true ? '1' : '0'
              item.DETPRECEN_TOTAL = Number(item.DETPRECEN_TOTAL);
              item.DETPRECEN_CANTIDAD = Number(item.DETPRECEN_CANTIDAD);
              item.DETPRECEN_COSTO = Number(item.DETPRECEN_COSTO);
              if (item.DETPRECEN_LINEA === 0) {
                item.ENCPRECEN_NUMERO = iterator.ENCPRECEN_NUMERO
                await this.conprecenService.insertarDetalleprecen(item);
                this.auditoriagral.registrarAuditoria('CON_DETPRECEN', iterator.ENCPRECEN_NUMERO, 'I',
                  '', '01', '', '', '', '').subscribe(() => { });
              } else {
                item.ENCPRECEN_NUMERO = iterator.ENCPRECEN_NUMERO
                await this.conprecenService.insertarDetalleprecen(item);
                this.auditoriagral.registrarAuditoria('CON_DETPRECEN', iterator.ENCPRECEN_NUMERO, 'A',
                  '', '01', '', '', '', '').subscribe(() => { });
              }
            }
          }
          await this.cancelar();
          this.messageService.add({
            key: 'precen',
            severity: 'success',
            summary: 'Información',
            detail: 'el registro se guardó con éxito '
          });
          this.spin=false
        }
      } else {
        if (this.conprecenService.encprecen[this.indicador].ENCPRECEN_FECHAINI.toString().includes('-')) {
          this.conprecenService.encprecen[this.indicador].ENCPRECEN_FECHAINI = this.datePipe.transform(this.conprecenService.encprecen[this.indicador].ENCPRECEN_FECHAINI, 'dd/MM/yyyy')
        }
        if (this.conprecenService.encprecen[this.indicador].ENCPRECEN_FECHAFIN.toString().includes('-')) {
          this.conprecenService.encprecen[this.indicador].ENCPRECEN_FECHAFIN = this.datePipe.transform(this.conprecenService.encprecen[this.indicador].ENCPRECEN_FECHAFIN, 'dd/MM/yyyy')
        }
        const rs = await this.conprecenService.insertarEncabezadoprecen(this.conprecenService.encprecen[this.indicador]);
        if (rs !== null) {
          for (const iterator of rs) {
            this.conprecenService.encprecen[this.indicador].ENCPRECEN_NUMERO = iterator.ENCPRECEN_NUMERO
            this.auditoriagral.registrarAuditoria('CON_ENCPRECEN', iterator.ENCPRECEN_NUMERO+'/'+this.conprecenService.encprecen[this.indicador].CLI_CODIGO
            +'/'+this.conprecenService.encprecen[this.indicador].CEN_CODIGO, 'A',
              '', '01', '', '', '', '').subscribe(() => { });
            for (const item of this.conprecenService.detprecen[this.indicador]) {
              item.DETPRECEN_ORIGENCON = item.DETPRECEN_ORIGENCON === true ? '1' : '0'
              item.DETPRECEN_TOTAL = Number(item.DETPRECEN_TOTAL);
              item.DETPRECEN_CANTIDAD = Number(item.DETPRECEN_CANTIDAD);
              item.DETPRECEN_COSTO = Number(item.DETPRECEN_COSTO);
              if (item.DETPRECEN_LINEA === 0) {
                item.ENCPRECEN_NUMERO = iterator.ENCPRECEN_NUMERO
                await this.conprecenService.insertarDetalleprecen(item);
                this.auditoriagral.registrarAuditoria('CON_DETPRECEN', iterator.ENCPRECEN_NUMERO, 'I',
                  '', '01', '', '', '', '').subscribe(() => { });
              } else {
                item.ENCPRECEN_NUMERO = iterator.ENCPRECEN_NUMERO
                await this.conprecenService.insertarDetalleprecen(item);
                this.auditoriagral.registrarAuditoria('CON_DETPRECEN', iterator.ENCPRECEN_NUMERO, 'A',
                  '', '01', '', '', '', '').subscribe(() => { });
              }
            }
          }
          await this.cancelar();
          this.messageService.add({
            key: 'precen',
            severity: 'success',
            summary: 'Información',
            detail: 'El registro se actualizó con éxito '
          });
          this.spin=false
        }
      }
      

    } catch (error) {
      this.messageService.add({
        key: 'precen',
        severity: 'error',
        summary: 'Información',
        detail: 'Hubo un error al guardar la información ' + error
      });
      this.spin=false
    }
  }
  nuevo() {
    this.btnNuevo = true;
    this.btnGuardar = false;
    this.btnBorrar = true;
    this.btnNuevoGrid = false;
    this.btnBorrarGrid = false;
    this.btnCancelarGrid = false;
    this.tipodetalle = 'A'
    this.conprecenService.encprecen[this.indicador] = {}
    this.conprecenService.detprecen[this.indicador] = []
    const dato: Encprecen = {
      ENCPRECEN_NUMERO: '',
      COM_CODIGO: '01',
      CEN_CODIGO: '',
      CLI_CODIGO: '',
      ENCPRECEN_DESCRIPCION: '',
      ENCPRECEN_FECHAFIN: new Date(),
      ENCPRECEN_FECHAINI: new Date(),
      CLI_NOMBRE: ''
    }
    this.conprecenService.encprecen[this.indicador] = dato;
    document.getElementById('contorno').style.pointerEvents = 'all';
    this.aggrid.habilitarGrid();
    document.getElementById('CLI_CODIGO').focus();
  }
  docSeleccionado(valor) {
    const indi = this.conprecenService.detprecen[this.indicador].indexOf(valor.data);
    
    if (valor.data.SELECCIONADO) {
      valor.data.DETPRECEN_ORIGENCON=true
    }else{
      valor.data.DETPRECEN_ORIGENCON=false
    }
    this.aggrid.refreshaggridindexSNMVSCROLL(this.conprecenService.detprecen[this.indicador], this.defaultColDefPrecen.objeto, indi - 1)
    this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' + this.defaultColDefPrecen.objeto].setFocusedCell(indi, 'SELECCIONADO');
  }
  botonesmodificar() {
    this.btnNuevo = true;
    this.btnGuardar = false;
    this.btnBorrar = true;
    this.btnNuevoGrid = false;
    this.btnBorrarGrid = false;
    this.btnCancelarGrid = false;
  }
  setFocus(event) {
    let element: any;
    switch (event.target.id) {
      case 'CLI_CODIGO': {
        this.busquedacliente(event.target.value);
        break;
      }
      case 'ENCPRECEN_DESCRIPCION': {
        //this.busquedacliente(event.target.value);
        element = document.getElementById('CEN_CODIGO');
        break;
      } case 'CEN_CODIGO': {
        //this.busquedacliente(event.target.value);
        //element = document.getElementById('CEN_CODIGO');
        this.busquedaCentroCostos(event.target.value)
        break;
      }
      default: {
        break;
      }
    }
    if (element === null || element === undefined) {
      return;
    } else {
      element.focus();
    }
  }
  async busquedacliente(parametro) {
    if (parametro === null) {
      parametro = '';
    }
    this.opcionbusqueda = 'cliente';
    this.types = [
      { label: 'Código', value: 'CLI_CODIGO' },
      { label: 'Nombre', value: 'CLI_NOMBRE' },
      { label: 'RucIde', value: 'CLI_RUCIDE' },
      { label: 'Zona', value: 'CLI_ZONA' },
      { label: 'Grupo', value: 'GRU_CODIGO' },
      { label: 'Contacto', value: 'CLI_CONTACTO' },
      { label: 'Placa', value: 'CLI_PLACA' },
      { label: 'NombreC', value: 'CLI_NOMBREC' },
    ];
    this.busquedacampos = [parametro, '', '', '', '', '', '', '', ''];
    this.tabla = 'VEN_MAECLIENTE';
    this.where = '';
    this.consulta='';
    if (parametro !== '' && parametro !== undefined && parametro !== null) {
      const eR = await this.conprecenService.erpBusquedaCliente(this.tabla, this.types[0].value, parametro);
      if (eR !== null) {
        if (eR[0] !== undefined) {
          this.manejarSeleccion(eR[0]);
          document.getElementById('ENCPRECEN_DESCRIPCION').focus();;
          return;
        }
      }
    }

    //this.spin = true;
    this.busquedaSer.busquedaVenMaeCliente3(parametro).subscribe((datos: any[]) => {
      this.spin = true;
      this.arregloCons = datos;
      // this.spin = false;
      this.displayDialogBusquedaFast = true;
      this.spin = false;
    });

  }
  manejarSeleccion(opcion) {
    if (this.opcionbusqueda === 'cliente') {
      this.conprecenService.encprecen[this.indicador].CLI_CODIGO = opcion.CLI_CODIGO;
      this.conprecenService.encprecen[this.indicador].CLI_NOMBRE = opcion.CLI_NOMBRE;
      document.getElementById('ENCPRECEN_DESCRIPCION').focus();;
    }
    if (this.opcionbusqueda === 'BUSCENCODIGO') {
      this.conprecenService.encprecen[this.indicador].CEN_CODIGO = opcion.CEN_CODIGO;
      this.conprecenService.encprecen[this.indicador].CEN_NOMBRE = opcion.CEN_NOMBRE;
    }
    if (this.opcionbusqueda === 'BUSREGISTRO') {
      this.encontrarregistro(opcion.ENCPRECEN_NUMERO)
    }
    this.displayDialogBusquedaFast = false

  }
  cerrarReportes() {
    this.displayDialogReportes = false
  }
  selectedPrecen(params) {
    if (params === 'nuevo') {
      this.nuevodetalle()
      return;
    }
    if (params === 'eliminar') {
      this.eliminardetalle()
      return;
    }
    if (params.object !== undefined) {
      this.selecteddetprecen = params.object;
      this.tipodetalle = this.selecteddetprecen.DETPRECEN_TIPODET;
    }
  }
  async eliminardetalle() {
    try {
      if (this.selecteddetprecen !== undefined && this.conprecenService.detprecen[this.indicador].length > 0) {
        this.confirmationService.confirm({
          message: 'Está seguro de eliminar el registro?',
          header: 'Pregunta',
          icon: 'pi pi-exclamation-triangle',
          key: 'cnfprecen',
          acceptLabel: 'Si',
          rejectLabel: 'No',
          accept: async () => {
            this.confirmationService.close();
            if (this.selecteddetprecen.DETPRECEN_LINEA !== 0) {
              await this.conprecenService.eliminarDetalleFact(this.selecteddetprecen)//.subscribe(async () => {
              this.conprecenService.detprecen[this.indicador].splice(this.conprecenService.detprecen[this.indicador].findIndex(
                detfac => detfac.LINEA === this.selecteddetprecen.LINEA),
                1);
              this.messageService.add({
                key: 'precen',
                severity: 'success',
                summary: 'Información',
                detail: 'El detalle se eliminó correctamente'
              });
              //CDPJ
              this.auditoriagral.registrarAuditoria('CON_DETPRECEN',
                this.conprecenService.encprecen[this.indicador].ENCPRECEN_NUMERO + '/' + this.selecteddetprecen.DETPRECEN_CODIGO + '/cantidad:'+
                this.selecteddetprecen.DETPRECEN_CANTIDAD+'/costo:'+this.selecteddetprecen.DETPRECEN_COSTO+'/total:'+this.selecteddetprecen.DETPRECEN_TOTAL
                , 'E',
                '', '01', '', '', '', '').subscribe();
              //CDPJ
              if (this.conprecenService.detprecen[this.indicador].length > 0) {
                this.selecteddetprecen = this.conprecenService.detprecen[this.indicador][this.conprecenService.detprecen[this.indicador].length - 1];
              }

              this.aggrid.refreshaggrid(this.conprecenService.detprecen[this.indicador], this.defaultColDefPrecen.objeto);


              //});

            } else {
              this.conprecenService.detprecen[this.indicador].splice(this.conprecenService.detprecen[this.indicador].findIndex(
                detfac => detfac.LINEA === this.selecteddetprecen.LINEA),
                1);
              this.messageService.add({
                key: 'precen',
                severity: 'success',
                summary: 'Información',
                detail: 'El detalle se eliminó correctamente'
              });
              if (this.conprecenService.detprecen[this.indicador].length > 0) {
                this.selecteddetprecen = this.conprecenService.detprecen[this.indicador][this.conprecenService.detprecen[this.indicador].length - 1];
              }


              this.aggrid.refreshaggrid(this.conprecenService.detprecen[this.indicador], this.defaultColDefPrecen.objeto);

            }

          },
          reject: () => {
            this.confirmationService.close();
          }
        });
      }
    } catch (error) {
      this.messageService.add({
        key: 'precen',
        severity: 'error',
        summary: 'Información',
        detail: 'Hubo un error al eliminar el detalle ' + error
      });
    }
  }
  nuevodetalle() {
    const detprecen: Detprecen = {};
    const indi = this.conprecenService.detprecen[this.indicador].indexOf(this.selecteddetprecen);
    detprecen.ENCPRECEN_NUMERO = this.conprecenService.encprecen[this.indicador].ENCPRECEN_NUMERO
    detprecen.COM_CODIGO = '01'
    detprecen.DETPRECEN_CODIGO = '';
    detprecen.DETPRECEN_DESCRIPCION = ''
    detprecen.DETPRECEN_LINEA = 0
    detprecen.DETPRECEN_CANTIDAD = Number('0').toFixed(2);
    detprecen.DETPRECEN_COSTO = Number('0').toFixed(2);
    detprecen.DETPRECEN_TOTAL = Number('0').toFixed(2);
    detprecen.DETPRECEN_TIPODET = this.tipodetalle
    detprecen.DETPRECEN_ORIGENCON = false,
    detprecen.SELECCIONADO=false,
    detprecen.LINEA=this.conprecenService.detprecen[this.indicador].length+1

    if (indi === -1) {
      this.conprecenService.detprecen[this.indicador].push(detprecen)
      this.selecteddetprecen = detprecen
      this.aggrid.refreshaggrid(this.conprecenService.detprecen[this.indicador], this.defaultColDefPrecen.objeto);
      this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' +
        this.defaultColDefPrecen.objeto].setFocusedCell((this.conprecenService.detprecen[this.indicador].length) - 1, 'DETPRECEN_CODIGO');
    } else {
      this.conprecenService.detprecen[this.indicador].splice(indi + 1, 0, detprecen);
      this.selecteddetprecen = detprecen
      this.aggrid.refreshaggrid(this.conprecenService.detprecen[this.indicador], this.defaultColDefPrecen.objeto);
      this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' +
        this.defaultColDefPrecen.objeto].setFocusedCell(indi + 1, 'DETPRECEN_CODIGO');
    }

  }
  async busquedaCentroCostos(parametro) {
    this.opcionbusqueda = 'BUSCENCODIGO'
    this.types = [
      { label: 'CÓDIGO', value: 'CEN_CODIGO' },
      { label: 'NOMBRE', value: 'CEN_NOMBRE' }
    ];

    this.busquedacampos = [parametro, ''];
    this.tabla = 'CON_MAECEN';
    this.where = ''
    this.consulta=''
    if (parametro !== '' && parametro !== undefined && parametro !== null) {
      const eR = await this.conprecenService.busquedaCentroCostos(parametro);
      if (eR !== null) {
        if (eR[0] !== undefined) {
          this.manejarSeleccion(eR[0]);
          return;
        }
      }
    }
    this.busquedaSer.busquedaConMaeCen2(parametro).subscribe((res: any[]) => {
      this.arregloCons = res;
      this.displayDialogBusquedaFast = true;
    });

  }
  cambioTab() {

  }
  cambiarTipo(valor) {
    this.tipodetalle = valor;
    // this.notRecRecepcion.DETNOTREC_TIPODET = valor;
  }
}
